import loadable from "@loadable/component";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { ANDROID_SIGNUP_CAPTURE_TYPES } from "web/react/components/email-capture-overlay/email-capture-overlay";
import withReduxProvider from "web/react/redux-provider";
import userProfiler from "web/script/modules/userprofiler";
import browser from "web/script/utils/browser";

const EmailCaptureOverlay = loadable(() =>
    import(
        /* webpackChunkName: "email-capture-overlay" */ "web/react/components/email-capture-overlay/email-capture-overlay"
    )
);

const EmailCaptureOverlayMembershipBenefits = loadable(() =>
    import(
        /* webpackChunkName: "email-membership-capture-overlay" */ "web/react/components/email-capture-overlay-membership-benefits/email-capture-overlay-membership-benefits"
    )
);

const EmailAppCaptureOverlay = loadable(() =>
    import(
        /* webpackChunkName: "email-app-capture-overlay" */ "web/react/components/email-app-capture-overlay/email-app-capture-overlay"
    )
);

const QRCodeOverlay = loadable(() =>
    import(
        /* webpackChunkName: "email-app-capture-overlay" */ "web/react/components/qrcode-overlay/qrcode-overlay"
    )
);

function mapStateToProps(state) {
    const { captureType, open, next, appDeeplinkPath } = state.customerCaptureOverlayReducer;
    return {
        captureType,
        overlayOpen: open,
        next: next,
        appDeeplinkPath,
    };
}

const USE_COMBINED_APP_EMAIL_MODAL = [
    "signup_feed_save",
    "signup_du",
    "signup_pdp_save",
    "event_counter",
    "feeds_product_card",
];

export function CustomerCaptureOverlay({ ...props }) {
    const { overlayOpen, captureType } = props;
    const useCombinedOverlay =
        browser.isSupportedMobileDevice &&
        !userProfiler.isLoggedIn() &&
        USE_COMBINED_APP_EMAIL_MODAL.includes(captureType);

    if (!overlayOpen) {
        return null;
    } else if (captureType === "qr_code") {
        return <QRCodeOverlay {...props} />;
    } else if (ANDROID_SIGNUP_CAPTURE_TYPES.includes(captureType)) {
        return (
            <EmailCaptureOverlayMembershipBenefits
                overlayOpen={overlayOpen}
                captureType={captureType}
                {...props}
            />
        );
    } else if (useCombinedOverlay) {
        return <EmailAppCaptureOverlay {...props} />;
    } else {
        return <EmailCaptureOverlay {...props} />;
    }
}
export default withReduxProvider(connect(mapStateToProps)(CustomerCaptureOverlay));
CustomerCaptureOverlay.propTypes = {
    captureType: PropTypes.oneOf([
        "signup_lead_save",
        "signup_pdp_save",
        "signup_feed_save",
        "signup_du",
        "signup_search",
        "stock_alert",
        "stock_alert_lead_return",
        "signup_oos_save",
        "event_counter",
        "qr_code",
        ...ANDROID_SIGNUP_CAPTURE_TYPES,
    ]),
    overlayOpen: PropTypes.bool,
};
